module.exports = __webpack_public_path__ + "static/img/testimony (54).0a90a0c2.jpg";